import React from "react";
import HeroPage from "../ones/PageHero";
import CallToAction from "../ones/CallToAction";
import Footer from "../ones/Footer";
import darImage from "../assets/dar.jpg"
import {
  MdPhoneInTalk,
  MdMailOutline,
  MdLocationOn,
  MdAccessTime,
  MdVerifiedUser,
  MdAssignment,
  MdBusinessCenter,
  MdMarkunreadMailbox,
} from "react-icons/md";

export default function ContactUs() {
  // Localized Hero Data passed to the shared component
  const heroData = {
    kicker: "Direct Executive Channels",
    title: "Connect With Our Certified Public Accountants & Advisors",
    description:
      "Reach out directly across our specialized practice streams or visit our permanent office locations in Dar es Salaam, Morogoro, and Dodoma.",
  };

  return (
    <div className="contact-page-global-wrapper">
      {/* PAGE HERO */}
      <HeroPage data={heroData} />

      {/* CORE STATUTORY DIRECTORY & DEPARTMENTS SECTION */}
      <section className="contact-main-grid-section py-5">
        <div className="container py-3">
          <div className="row g-5">
            {/* LEFT COLUMN: THE PREMIUM DEPARTMENTAL DIRECTORY (Replaces Form) */}
            <div className="col-lg-7" data-aos="fade-right">
              <div className="contact-directory-container p-4 p-md-5 border rounded bg-white shadow-sm">
                <span className="directory-pre-title text-secondary text-uppercase font-weight-bold tracking-wider">
                  Direct Access
                </span>
                <h2 className="directory-main-title text-primary font-weight-bold mt-1 mb-4">
                  Practice Stream Communications
                </h2>
                <p className="text-muted font-15 mb-4">
                  As an active National Board of Accountants and Auditors (NBAA)
                  member firm, your queries are routed straight to certified
                  professionals within our structural framework.
                </p>

                {/* PRACTICE DEPARTMENTS STACK */}
                <div className="d-flex flex-column gap-4">
                  {/* STREAM 1 */}
                  <div className="department-communication-strip p-3 rounded d-flex flex-column flex-md-row align-items-md-center justify-content-between gap-3">
                    <div className="d-flex align-items-start gap-3">
                      <div className="stream-icon-box bg-primary text-white">
                        <MdVerifiedUser />
                      </div>
                      <div>
                        <h5 className="text-primary font-weight-bold font-16 m-0">
                          Statutory Audit & Assurance Desk
                        </h5>
                        <small className="text-muted d-block mt-1">
                          Led by Certified Partners (NBAA Members)
                        </small>
                      </div>
                    </div>
                    <div className="text-md-end">
                      <a
                        href="mailto:audit@blessingconsultancy.com"
                        className="stream-action-link font-weight-bold font-14 text-primary d-block"
                      >
                        audit@blessingconsultancy.com
                      </a>
                    </div>
                  </div>

                  {/* STREAM 2 */}
                  <div className="department-communication-strip p-3 rounded d-flex flex-column flex-md-row align-items-md-center justify-content-between gap-3">
                    <div className="d-flex align-items-start gap-3">
                      <div className="stream-icon-box bg-primary text-white">
                        <MdAssignment />
                      </div>
                      <div>
                        <h5 className="text-primary font-weight-bold font-16 m-0">
                          Tax Engineering & Consultancy Hub
                        </h5>
                        <small className="text-muted d-block mt-1">
                          TRA Compliance, Filings & Corporate Tax Reviews
                        </small>
                      </div>
                    </div>
                    <div className="text-md-end">
                      <a
                        href="mailto:tax@blessingconsultancy.com"
                        className="stream-action-link font-weight-bold font-14 text-primary d-block"
                      >
                        tax@blessingconsultancy.com
                      </a>
                    </div>
                  </div>

                  {/* STREAM 3 */}
                  <div className="department-communication-strip p-3 rounded d-flex flex-column flex-md-row align-items-md-center justify-content-between gap-3">
                    <div className="d-flex align-items-start gap-3">
                      <div className="stream-icon-box bg-primary text-white">
                        <MdBusinessCenter />
                      </div>
                      <div>
                        <h5 className="text-primary font-weight-bold font-16 m-0">
                          Strategic Accounting & Advisory Services
                        </h5>
                        <small className="text-muted d-block mt-1">
                          Financial Frameworks, Corporate Secrets & Systems
                        </small>
                      </div>
                    </div>
                    <div className="text-md-end">
                      <a
                        href="mailto:info@blessingconsultancy.com"
                        className="stream-action-link font-weight-bold font-14 text-primary d-block"
                      >
                        info@blessingconsultancy.com
                      </a>
                    </div>
                  </div>
                </div>

                {/* POSTAL REGISTRY BOX */}
                <div className="mt-4 p-3 bg-light-surface-tint border rounded d-flex align-items-center gap-3">
                  <div className="text-secondary fs-3 line-height-1">
                    <MdMarkunreadMailbox />
                  </div>
                  <div>
                    <span className="font-weight-bold d-block text-primary font-14">
                      Official Postal Registry
                    </span>
                    <span className="text-muted font-13">
                      P.O. Box 1401, Morogoro, Tanzania
                    </span>
                  </div>
                </div>
              </div>
            </div>

            {/* RIGHT COLUMN: CENTRALIZED CHANNELS & VISUAL HOOK */}
            <div className="col-lg-5" data-aos="fade-left">
              <div className="contact-meta-sidebar-stack d-flex flex-column gap-4">
                {/* TELECOMMUNICATIONS CARD */}
                <div className="meta-info-card p-4 border rounded bg-white shadow-sm">
                  <h4 className="text-primary font-weight-bold mb-4 border-bottom pb-2">
                    Centralized Channels
                  </h4>

                  <div className="d-flex flex-column gap-3">
                    <div className="info-row-item d-flex align-items-start gap-3">
                      <div className="info-icon-wrapper bg-light-primary text-primary">
                        <MdPhoneInTalk />
                      </div>
                      <div>
                        <span className="info-row-label d-block text-muted font-12">
                          Communications Registry
                        </span>
                        <a
                          href="tel:+255222123456"
                          className="info-row-link text-primary font-weight-bold font-15"
                        >
                          +255 (0) 22 212 3456
                        </a>
                        <span className="d-block text-muted font-13 mt-0.5">
                          Primary Intake Management Line
                        </span>
                      </div>
                    </div>

                    <div className="info-row-item d-flex align-items-start gap-3">
                      <div className="info-icon-wrapper bg-light-primary text-primary">
                        <MdMailOutline />
                      </div>
                      <div>
                        <span className="info-row-label d-block text-muted font-12">
                          General Electronic Intake
                        </span>
                        <a
                          href="mailto:info@blessingconsultancy.com"
                          className="info-row-link text-primary font-weight-bold font-15"
                        >
                          info@blessingconsultancy.com
                        </a>
                      </div>
                    </div>

                    <div className="info-row-item d-flex align-items-start gap-3">
                      <div className="info-icon-wrapper bg-light-primary text-primary">
                        <MdAccessTime />
                      </div>
                      <div>
                        <span className="info-row-label d-block text-muted font-12">
                          Business Hours
                        </span>
                        <span className="info-row-text text-dark font-weight-bold font-14 d-block">
                          Mon — Fri: 08:00 AM – 05:00 PM
                        </span>
                        <small className="d-block text-muted font-12 mt-1 bg-light px-2 py-1 rounded">
                          * Note: Staff observe internal morning technical
                          reviews on Fridays.
                        </small>
                      </div>
                    </div>
                  </div>
                </div>

                {/* PREMIUM BRAND IMAGE PLACEHOLDER */}
                <div className="recommended-image-showcase-card overflow-hidden border rounded position-relative shadow-sm">
                  <img
                    src={darImage}
                    alt="Blessing Management Consultancy Office Area"
                    className="contact-showcase-img w-100 d-block"
                  />
                  <div className="image-card-caption-overlay p-3 text-white">
                    <h5 className="font-weight-bold m-0 d-flex align-items-center gap-2 font-13">
                      <MdBusinessCenter className="text-secondary" /> Samora
                      Avenue Financial Hub
                    </h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* MULTI-OFFICE GEOLOCATION FOOTPRINT */}
      <section className="office-footprint-section py-5 bg-light-surface-tint">
        <div className="container">
          <div
            className="section-header-centered text-center mb-5"
            data-aos="fade-up"
          >
            <span className="overview-kicker text-secondary text-uppercase font-weight-bold tracking-wider">
              Our Grid
            </span>
            <h2 className="text-primary font-weight-bold mt-1">
              Physical Office Footprint
            </h2>
            <div className="kicker-line mx-auto bg-secondary mt-2" />
          </div>

          <div className="row g-4 justify-content-center mb-5">
            {/* DAR ES SALAAM HEADQUARTERS */}
            <div
              className="col-md-6 col-lg-4"
              data-aos="fade-up"
              data-aos-delay="0"
            >
              <div className="branch-location-card h-100 p-4 bg-white border rounded shadow-sm">
                <div className="d-flex align-items-center gap-2 text-primary mb-3">
                  <MdLocationOn className="fs-4 text-secondary" />
                  <h4 className="m-0 font-18 font-weight-bold">
                    Dar es Salaam (HQ)
                  </h4>
                </div>
                <p className="branch-address text-muted font-14 mb-0">
                  Plot No 582/9, Samora Avenue / Mkwepu Street Junction,
                  <br />
                  Commercial District, Dar es Salaam, Tanzania.
                </p>
              </div>
            </div>

            {/* MOROGORO OFFICE */}
            <div
              className="col-md-6 col-lg-4"
              data-aos="fade-up"
              data-aos-delay="100"
            >
              <div className="branch-location-card h-100 p-4 bg-white border rounded shadow-sm">
                <div className="d-flex align-items-center gap-2 text-primary mb-3">
                  <MdLocationOn className="fs-4 text-secondary" />
                  <h4 className="m-0 font-18 font-weight-bold">
                    Morogoro Office
                  </h4>
                </div>
                <p className="branch-address text-muted font-14 mb-0">
                  Pamba House Building,
                  <br />
                  Old Dar es Salaam Road,
                  <br />
                  Morogoro, Tanzania.
                </p>
              </div>
            </div>

            {/* DODOMA OFFICE */}
            <div
              className="col-md-6 col-lg-4"
              data-aos="fade-up"
              data-aos-delay="200"
            >
              <div className="branch-location-card h-100 p-4 bg-white border rounded shadow-sm">
                <div className="d-flex align-items-center gap-2 text-primary mb-3">
                  <MdLocationOn className="fs-4 text-secondary" />
                  <h4 className="m-0 font-18 font-weight-bold">
                    Dodoma Branch
                  </h4>
                </div>
                <p className="branch-address text-muted font-14 mb-0">
                  Capital City Regional Hub,
                  <br />
                  Strategic Expansion Pipeline Area,
                  <br />
                  Dodoma, Tanzania.
                </p>
              </div>
            </div>
          </div>

          {/* RESPONSIVE GOOGLE MAPS EMBED CONTAINER */}
          <div
            className="google-maps-embed-wrapper border rounded shadow-sm overflow-hidden"
            data-aos="zoom-in"
          >
            <iframe
              title="Blessing Management Consultancy Location Map"
              src="https://maps.google.com/maps?q=Samora%20Avenue%20%26%20Mkwepu%20Street%2C%20Dar%20es%20Salaam%2C%20Tanzania&t=&z=16&ie=UTF8&iwloc=&output=embed"
              width="100%"
              height="420"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </div>
      </section>
    </div>
  );
}
